// AI 개발실(#2624 · ④-S 화면 최소판 · patch_aidevroom_4S_screen_min) — 도구 목록·새 도구 · 말 보내기·멈춤 · 세션 상태 ·
// 미리보기(같은 출처 틀 /aidev-frame.html → 앱 iframe) · 확인표 ⓐ 결과·«맞다» · 사람 항목 · 교체 승인 · 명세 승인 카드 · 보류 알림.
// 🔴 판정·전이는 서버(routers/aidevroom.py)가 한다 — 화면은 HTTP 를 부르고 받은 값을 글자로 그린다(HTML 로 넣지 않는다).
// 🔴 이 화면은 메시지를 받지 않는다(처리기 0) — 틀에 보내기만 하고, 받는 출처는 늘 window.location.origin(틀 = 같은 출처).
// 🔴 승인(명세·교체·«맞다»)은 이 화면 단추를 사람이 누를 때만 — 틀·앱에서 오는 무엇으로도 부르지 않는다.
// 🔴 틀은 미리보기를 열 때마다 새로 만든다(같은 앱 주소여도 — 옛 묶음 페이지에 새 view 의 «맞다»가 붙지 않게).
// 🔴 토큰 갱신은 탭이 보일 때만(숨김 탭이 미리보기를 영원히 살리지 않게) — 숨김에서 돌아오면 그때 한 번.
// 미리보기 상자는 세 칸 위 전체 폭 띠(#3559) — 접어도 iframe 은 빼지 않는다(높이만 0 · 틀을 다시 만들지 않는다).
// «도구 보관»은 되살림이 없다 — 서버가 세션 멈춤 → 정리 → archived 전이를 한다(정리 잠금이면 409 · 보관 0).
// 메뉴 노출·URL 가드는 utils/menuAccess(apps) · 실제 차단은 서버(require_menu("apps")).
// «사용법 묻기»(#3685) — 제목 옆 단추 → 떠 있는 판(넓은 화면 오른쪽 아래 · 모바일 아래 전체 폭)에서 아우리에게 묻는다.
//   대화는 저장하지 않는다(이 화면 state 만 · 새로고침하면 사라짐) — 보낼 때마다 직전 문답을 helpPayload 로 잘라 같이 보낸다.
//   사용법 문서·모델·한도는 서버(routers/aidevroom.py /help · services/aidev/help_guide.py)가 정한다.
//   아우리 답만 Markdown(compact · 날 HTML 없음)로 그린다(#3725) — 사용자 말은 평문 · state 의 답은 날 마크다운 문자열 그대로.
import { useCallback, useEffect, useRef, useState } from 'react';
import AppShell from '../components/AppShell';
import Markdown from '../components/Markdown';
import useIsMobile from '../hooks/useIsMobile';
import { aidevAPI } from '../api/client';
import { tabbarCalc } from '../lib/tabbarMetrics';
import { mdHardBreaks } from '../utils/meetingUtil';
import { COLORS, SHADOW, btn, card, input } from '../utils/uiStyles';

const FRAME_SRC = '/aidev-frame.html';
const FRAME_W = 1280;                 // 틀 논리 크기(④-I2 렌더러 래퍼와 같은 크기) — 좁으면 scale 로 줄여 보인다
const FRAME_H = 800;
export const MIN_SCALE = 0.6;         // 이보다 작게는 줄이지 않는다(글씨를 읽을 수 있게) — 좁으면 가로 스크롤
const POLL_MS = 3000;
const REFRESH_BEFORE_S = 60;          // 앱 토큰(600초) 만료 60초 전에 다시 받는다
const MAX_TEXT = 20000;
const REDEPLOY_AFTER_CHANGING = 3;    // «바뀌는 중»을 이만큼 연달아 받으면 «다시 올리기»
const STOP_BANNER = 'AI 개발실이 관리자에 의해 정지되었습니다';
const CARD_GONE_TEXT = '교체 카드가 사라졌습니다 — AI 에게 다시 요청해 주세요';
const SHIPPER_ALL = '화주 전체(내 범위 안)';
const NOTIFY_ITEM_NOTE = '사람 확인 필요 — 알림은 화면으로 판정하지 않습니다';
const STATUS_LABEL = { idle: '쉬는 중', running: '작업 중', stopped: '멈춤', failed: '실패' };
// «사용법 묻기» — 서버(routers/aidevroom.py HELP_*)와 같은 상한.
const HELP_MAX_TEXT = 2000;           // 질문 한 줄
const HELP_MAX_ANSWER = 8000;         // 앞선 답 한 줄(보낼 때 자른다)
const HELP_MAX_TURNS = 20;
const HELP_MAX_TOTAL = 20000;
const HELP_LIMIT_TEXT = '이번 달 사용 한도를 넘었습니다';
const HELP_TIMEOUT_TEXT = '답이 늦어 기다리기를 멈췄습니다 — 잠시 뒤 다시 물어 주세요';
// 폭 0·방향 제어 문자 — 승인 카드에서는 \uXXXX 로 보이게 바꾼다(4P :74 ③).
const INVISIBLE_RE = /[؜᠎​-‏‪-‮⁠-⁤⁦-⁩﻿]/g;

// 상자 폭 → 1280 논리 크기를 줄여 보일 비율(MIN_SCALE~1) · 폭을 아직 못 쟀으면 1.
export function previewScale(boxWidth) {
  return boxWidth > 0 ? Math.max(MIN_SCALE, Math.min(1, boxWidth / FRAME_W)) : 1;
}

const showInvisible = (value) => String(value)
  .replace(INVISIBLE_RE, (ch) => `\\u${ch.charCodeAt(0).toString(16).toUpperCase().padStart(4, '0')}`);

// axios 오류 → {status, reason, message} — 서버 detail 은 {reason, message} 또는 글자.
const errInfo = (err) => {
  const status = err && err.response ? err.response.status : 0;
  const detail = err && err.response && err.response.data ? err.response.data.detail : null;
  if (detail && typeof detail === 'object') {
    return { status, reason: detail.reason || '', message: detail.message || detail.reason || '요청을 마치지 못했습니다' };
  }
  return { status, reason: '', message: typeof detail === 'string' && detail ? detail : '요청을 마치지 못했습니다' };
};

// 보낼 문답 — 뒤에서부터 20개 · 합 20,000자 이하 · 앞선 답 한 줄은 8,000자까지 · 자른 뒤 맨 앞이 답이면 버린다(첫 줄은 늘 질문).
export function helpPayload(turns) {
  const out = [];
  let total = 0;
  for (let i = turns.length - 1; i >= 0 && out.length < HELP_MAX_TURNS; i -= 1) {
    const turn = turns[i];
    const content = turn.role === 'assistant' ? turn.content.slice(0, HELP_MAX_ANSWER) : turn.content;
    if (total + content.length > HELP_MAX_TOTAL) break;
    total += content.length;
    out.unshift({ role: turn.role, content });
  }
  while (out.length > 0 && out[0].role !== 'user') out.shift();
  return out;
}

// 도움말 오류 문구 — 한도 문구는 채팅 한도 응답(429 LIMIT_EXCEEDED)일 때만 · 시간 초과 · 그 밖은 errInfo.
const helpErrText = (err) => {
  const detail = err && err.response && err.response.data ? err.response.data.detail : null;
  if (err && err.response && err.response.status === 429 && detail && typeof detail === 'object'
    && detail.code === 'LIMIT_EXCEEDED') return HELP_LIMIT_TEXT;
  if (err && !err.response && (err.code === 'ECONNABORTED' || err.code === 'ETIMEDOUT')) return HELP_TIMEOUT_TEXT;
  return errInfo(err).message;
};

const summaryText = (s) => {
  if (!s || typeof s !== 'object') return '시험 요약 없음';
  const expect = (Array.isArray(s.expect) ? s.expect : [])
    .map((e) => `${e.selector} ${e.kind} ${JSON.stringify(e.value)}`).join(' · ');
  return `데이터셋 ${(s.datasets || []).join(', ') || '-'} · 경우 ${s.cases ?? 0} · 단계 ${(s.steps || []).join('→') || '-'}`
    + (expect ? ` · 기대 ${expect}` : '');
};

const lastResultText = (lr) => {
  if (!lr || typeof lr !== 'object') return '';
  if (lr.kind === 'replace_card') return '교체 카드가 왔습니다 — 확인 칸에서 보고 승인하세요';
  if (lr.kind === 'spec_approval') return '명세 승인이 필요합니다 — 확인 칸의 명세 카드를 보고 승인하세요';
  return typeof lr.text === 'string' ? lr.text : '';
};

const section = { ...card, padding: '12px 14px', marginBottom: '10px' };
const h2 = { margin: '0 0 8px', fontSize: '14px', fontWeight: 600, color: COLORS.text };
const sub = { fontSize: '12px', color: COLORS.textSub };
const warnBox = { fontSize: '12px', color: COLORS.dangerText, background: COLORS.dangerSoft, padding: '6px 8px', borderRadius: '5px', margin: '6px 0' };

export default function AidevRoomPage() {
  const mobile = useIsMobile();
  const [tools, setTools] = useState([]);
  const [monthCost, setMonthCost] = useState(null);
  const [listMsg, setListMsg] = useState('');
  const [newName, setNewName] = useState('');
  const [toolId, setToolId] = useState(null);
  const [view, setView] = useState(null);
  const [text, setText] = useState('');
  const [notice, setNotice] = useState('');
  const [sending, setSending] = useState(false);
  const [preview, setPreview] = useState(null);          // {url, viewId, token, exp, key}
  const [previewMsg, setPreviewMsg] = useState('');
  const [changing, setChanging] = useState(0);
  const [redeploying, setRedeploying] = useState(false);
  const [spec, setSpec] = useState(null);
  const [specMsg, setSpecMsg] = useState('');
  const [notify, setNotify] = useState(null);
  const [notifyOpen, setNotifyOpen] = useState(false);
  const [checkMsg, setCheckMsg] = useState('');
  const [cardGone, setCardGone] = useState(false);
  const [approvedHash, setApprovedHash] = useState(null);
  const [human, setHuman] = useState({ utteranceId: '', text: '', expect: '' });
  const [boxWidth, setBoxWidth] = useState(0);
  const [previewFolded, setPreviewFolded] = useState(false);
  const [archiving, setArchiving] = useState(false);
  // «사용법 묻기» — 이 화면 state 만(도구 선택·폴링과 무관 · 저장 없음).
  const [helpOpen, setHelpOpen] = useState(false);
  const [helpTurns, setHelpTurns] = useState([]);        // [{role:'user'|'assistant', content}]
  const [helpText, setHelpText] = useState('');
  const [helpBusy, setHelpBusy] = useState(false);
  const [helpErr, setHelpErr] = useState('');
  const helpToggleRef = useRef(null);
  const helpInputRef = useRef(null);
  const toolRef = useRef(null);
  const frameRef = useRef(null);
  const frameReadyRef = useRef(false);
  const frameSeqRef = useRef(0);
  const pendingRefreshRef = useRef(false);
  const hadCardRef = useRef(false);
  const prevStatusRef = useRef(null);
  const boxRef = useRef(null);

  // 목록 → 배열 | null(못 읽음 — 부르는 쪽이 «빈 목록»과 구별한다).
  const loadTools = useCallback(async () => {
    try {
      const { data } = await aidevAPI.tools();
      const list = Array.isArray(data.tools) ? data.tools : [];
      setTools(list);
      setMonthCost(typeof data.month_cost_usd === 'number' ? data.month_cost_usd : null);
      setListMsg('');
      return list;
    } catch (err) {
      setListMsg(errInfo(err).message);
      return null;
    }
  }, []);

  const loadView = useCallback(async (id) => {
    try {
      const { data } = await aidevAPI.tool(id);
      if (toolRef.current === id) setView(data);
    } catch (err) {
      if (toolRef.current !== id) return;
      const info = errInfo(err);
      setNotice(info.message);
      if (info.status === 404) setView(null);
    }
  }, []);

  const loadSpec = useCallback(async (id) => {
    try {
      const { data } = await aidevAPI.specCard(id);
      if (toolRef.current === id) { setSpec(data); setSpecMsg(''); }
    } catch (err) {
      if (toolRef.current !== id) return;
      const info = errInfo(err);
      setSpec(null);
      setSpecMsg(info.status === 404 ? '승인할 명세가 아직 없습니다' : info.message);
    }
  }, []);

  const loadNotify = useCallback(async (id) => {
    try {
      const { data } = await aidevAPI.notify(id);
      if (toolRef.current === id) setNotify(data);
    } catch (err) {
      if (toolRef.current === id) setNotify(null);
    }
  }, []);

  const selectTool = useCallback((id) => {
    toolRef.current = id;
    setToolId(id);
    setView(null);
    setPreview(null);
    setPreviewFolded(false);
    setPreviewMsg('');
    setChanging(0);
    setNotice('');
    setSpec(null);
    setSpecMsg('');
    setNotify(null);
    setNotifyOpen(false);
    setCheckMsg('');
    setCardGone(false);
    setApprovedHash(null);
    setHuman({ utteranceId: '', text: '', expect: '' });
    hadCardRef.current = false;
    prevStatusRef.current = null;
    pendingRefreshRef.current = false;
    loadView(id);
    loadSpec(id);
    loadNotify(id);
  }, [loadView, loadSpec, loadNotify]);

  useEffect(() => {
    loadTools().then((list) => {
      if (toolRef.current === null && list && list.length > 0) selectTool(list[0].tool_id);
    });
  }, []);

  // 작업 중이면 3초마다 다시 읽는다 · 작업이 끝나면 명세 카드·알림·도구 목록(비용)을 한 번 새로.
  useEffect(() => {
    if (!view || !toolId) return undefined;
    const prev = prevStatusRef.current;
    prevStatusRef.current = view.status;
    if (prev === 'running' && view.status !== 'running') {
      loadSpec(toolId);
      loadNotify(toolId);
      loadTools();
    }
    if (view.status !== 'running') return undefined;
    const timer = setTimeout(() => { loadView(toolId); }, POLL_MS);
    return () => clearTimeout(timer);
  }, [view, toolId]);

  // 본 교체 카드가 (여기서 승인하지 않았는데) 없어지면 알린다.
  useEffect(() => {
    const lr = view ? view.last_result : null;
    if (lr && lr.kind === 'replace_card' && lr.card) {
      hadCardRef.current = true;
      setCardGone(false);
    } else if (view && hadCardRef.current) {
      hadCardRef.current = false;
      setCardGone(true);
    }
  }, [view]);

  // 띠 상자 폭 → 1280 논리 크기를 줄여 보일 비율(previewScale).
  const frameKey = preview ? preview.key : null;
  useEffect(() => {
    const measure = () => setBoxWidth(boxRef.current ? boxRef.current.clientWidth : 0);
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [frameKey, mobile, previewFolded]);
  const scale = previewScale(boxWidth);

  // 틀로 보내기 — 같은 출처 틀에만(받는 출처를 못 박는다) · 틀이 다 싣기 전엔 보내지 않는다.
  const postToFrame = useCallback((message) => {
    const frame = frameRef.current;
    const win = frame ? frame.contentWindow : null;
    if (!win || !frameReadyRef.current) return false;
    try {
      win.postMessage(message, window.location.origin);
    } catch (e) {
      return false;
    }
    return true;
  }, []);

  const onFrameLoad = () => {
    frameReadyRef.current = true;
    if (preview) postToFrame({ type: 'aidev:show', url: preview.url, token: preview.token });
  };

  const refreshToken = useCallback(async () => {
    const id = toolRef.current;
    if (!id) return;
    try {
      const { data } = await aidevAPI.previewToken(id);
      if (toolRef.current !== id) return;
      setPreview((prev) => (prev ? { ...prev, token: data.app_token, exp: data.token_exp } : prev));
      postToFrame({ type: 'aidev:token', token: data.app_token });
    } catch (err) {
      if (toolRef.current !== id) return;
      const info = errInfo(err);
      setPreviewMsg(info.message);
      if (info.reason === 'preview_gone' || info.reason === 'no_preview') {
        setPreview(null);
        loadView(id);
      }
    }
  }, [postToFrame, loadView]);

  const previewExp = preview ? preview.exp : null;
  useEffect(() => {
    if (previewExp == null) return undefined;
    const wait = Math.max(0, (previewExp - REFRESH_BEFORE_S) * 1000 - Date.now());
    const timer = setTimeout(() => {
      if (document.visibilityState === 'visible') refreshToken();
      else pendingRefreshRef.current = true;
    }, wait);
    return () => clearTimeout(timer);
  }, [previewExp, refreshToken]);

  useEffect(() => {
    const onVisibility = () => {
      if (document.visibilityState !== 'visible' || !pendingRefreshRef.current) return;
      pendingRefreshRef.current = false;
      refreshToken();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, [refreshToken]);

  const createTool = async (e) => {
    e.preventDefault();
    setListMsg('');
    try {
      const { data } = await aidevAPI.createTool(newName);
      setNewName('');
      await loadTools();
      selectTool(data.tool_id);
    } catch (err) {
      setListMsg(errInfo(err).message);
    }
  };

  const send = async () => {
    if (!toolId || !text.trim() || sending) return;
    setSending(true);
    setNotice('');
    try {
      await aidevAPI.send(toolId, text);
      setText('');
      await loadView(toolId);
    } catch (err) {
      setNotice(errInfo(err).message);
    } finally {
      setSending(false);
    }
  };

  const stop = async () => {
    try {
      await aidevAPI.stop(toolId);
    } catch (err) {
      setNotice(errInfo(err).message);
    }
    loadView(toolId);
  };

  // 도구 보관(되살림 없음) — 확인 창 → 서버(세션 멈춤 → 정리 → archived) → 목록을 다시 읽는다.
  // 409(purge_busy·tool_state)·그 밖 실패는 서버 문구 그대로 · 도구는 목록·선택 그대로.
  const archiveTool = async () => {
    const id = toolId;
    if (id == null || archiving) return;
    const current = tools.find((t) => t.tool_id === id);
    const name = current ? current.name : (view && view.tool ? view.tool.name : '');
    if (!window.confirm(`«${name}» 도구를 보관합니다. 목록에서 빠지고 되살릴 수 없습니다. 미리보기 앱도 내려갑니다.`)) return;
    setArchiving(true);
    setListMsg('');
    try {
      await aidevAPI.archive(id);
    } catch (err) {
      setListMsg(errInfo(err).message);
      setArchiving(false);
      return;
    }
    const list = await loadTools();
    setArchiving(false);
    if (list === null) {                                      // 목록을 못 읽었다 — 선택은 그대로
      setListMsg('보관했습니다 — 목록을 다시 읽지 못했습니다. 새로고침해 주세요');
      return;
    }
    if (toolRef.current !== id) return;                       // 그사이 다른 도구를 골랐다
    if (list.length > 0) {
      selectTool(list[0].tool_id);
    } else {
      // selectTool(null) 은 부르지 않는다(/api/aidev/tools/null 을 친다).
      toolRef.current = null;
      setToolId(null);
      setView(null);
      setPreview(null);
    }
  };

  const openPreview = async () => {
    const id = toolId;
    if (!id) return;
    setPreviewMsg('');
    try {
      const { data } = await aidevAPI.previewOpen(id);
      if (toolRef.current !== id) return;
      frameSeqRef.current += 1;
      frameReadyRef.current = false;
      pendingRefreshRef.current = false;
      setChanging(0);
      setPreviewFolded(false);                                // 접힌 채 새 틀이 높이 0 상자에 실리지 않게
      setPreview({ url: data.url, viewId: data.view_id, token: data.app_token, exp: data.token_exp, key: frameSeqRef.current });
    } catch (err) {
      if (toolRef.current !== id) return;
      const info = errInfo(err);
      if (info.reason === 'preview_changing') setChanging((n) => n + 1);
      if (info.reason === 'preview_gone' || info.reason === 'no_preview') {
        setPreview(null);
        loadView(id);
      }
      setPreviewMsg(info.message);
    }
  };

  const redeploy = async () => {
    const id = toolId;
    setRedeploying(true);
    setPreviewMsg('미리보기를 다시 올리는 중…');
    try {
      await aidevAPI.redeploy(id);
      setChanging(0);
      setPreview(null);
      setPreviewMsg('다시 올렸습니다 — «미리보기 열기»를 누르세요');
      await loadView(id);
    } catch (err) {
      setPreviewMsg(errInfo(err).message);
    } finally {
      setRedeploying(false);
    }
  };

  const confirmSeen = async (itemId, resultId) => {
    if (!preview) return;
    const body = { view_id: preview.viewId };
    if (itemId != null) body.item_id = itemId;
    if (resultId != null) body.result_id = resultId;
    try {
      await aidevAPI.confirm(body);
      setCheckMsg(itemId == null ? '전체 «맞다»를 남겼습니다' : '«맞다»를 남겼습니다');
      loadView(toolId);
    } catch (err) {
      const info = errInfo(err);
      setCheckMsg(info.status === 409 ? '미리보기를 다시 여세요' : info.message);
    }
  };

  const addHuman = async (e) => {
    e.preventDefault();
    try {
      await aidevAPI.humanItem(toolId, {
        utterance_id: Number(human.utteranceId), text: human.text, expect_plain: human.expect,
      });
      setHuman({ utteranceId: '', text: '', expect: '' });
      setCheckMsg('사람 확인 항목을 더했습니다');
      loadView(toolId);
    } catch (err) {
      setCheckMsg(errInfo(err).message);
    }
  };

  const approveReplace = async (c) => {
    try {
      await aidevAPI.replace(toolId, {
        version_id: c.version_id, item_id: c.item_id, utterance_id: c.utterance_id,
        new_item: c.new_item, proposal_hash: c.proposal_hash,
      });
      hadCardRef.current = false;
      setApprovedHash(c.proposal_hash);
      setCheckMsg('항목을 바꿨습니다');
      loadView(toolId);
    } catch (err) {
      setCheckMsg(errInfo(err).message);
    }
  };

  const approveSpec = async () => {
    if (!spec) return;
    try {
      await aidevAPI.specApprove(toolId, { version_id: spec.version_id, spec_hash: spec.spec_hash });
      setSpecMsg('명세를 승인했습니다');
    } catch (err) {
      const info = errInfo(err);
      setSpecMsg(info.status === 409 ? '명세가 바뀌었습니다 — 다시 보고 승인' : info.message);
    }
    loadSpec(toolId);
  };

  // ── «사용법 묻기» ──
  const closeHelp = () => {
    setHelpOpen(false);
    if (helpToggleRef.current) helpToggleRef.current.focus();
  };

  useEffect(() => {
    if (!helpOpen) return undefined;
    if (!mobile && helpInputRef.current) helpInputRef.current.focus();
    const onKey = (e) => { if (e.key === 'Escape') closeHelp(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [helpOpen]);

  // 묻기 — 질문을 바로 목록에 보이고, 실패하면 목록에서 빼고 입력창에 되돌린다(질문이 연달아 쌓이지 않게).
  const askHelp = async (raw = helpText) => {
    const question = String(raw).trim();
    if (!question || helpBusy) return;
    const before = helpTurns;
    const turns = [...before, { role: 'user', content: question }];
    setHelpTurns(turns);
    setHelpText('');
    setHelpErr('');
    setHelpBusy(true);
    try {
      const { data } = await aidevAPI.help(helpPayload(turns));
      setHelpTurns([...turns, { role: 'assistant', content: String((data && data.answer) || '') }]);
    } catch (err) {
      setHelpTurns(before);
      setHelpText(question);
      setHelpErr(helpErrText(err));
    } finally {
      setHelpBusy(false);
    }
  };

  const helpKeyDown = (e) => {
    if (e.key !== 'Enter' || e.shiftKey) return;
    // 한글 조합 중의 Enter(조합 확정)는 보내기가 아니다 — 조합이 끝난 뒤 keydown 이 한 번 더 온다.
    if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
    e.preventDefault();
    // state 가 아니라 입력칸의 현재 값을 읽는다(조합 직후 state 는 한 박자 늦다).
    askHelp(e.currentTarget.value);
  };

  const clearHelp = () => {
    setHelpTurns([]);
    setHelpErr('');
  };

  const stopped = !!(view && view.global_stop);
  const running = !!(view && view.status === 'running');
  const items = view && Array.isArray(view.items) ? view.items : [];
  const results = new Map((view && Array.isArray(view.results) ? view.results : []).map((r) => [r.item_id, r]));
  const pub = view && view.publishable ? view.publishable : null;
  const blocking = pub && Array.isArray(pub.blocking) ? pub.blocking : [];
  const counts = new Map((pub && Array.isArray(pub.counts) ? pub.counts : []).map((c) => [c.item_id, c]));
  const unresolved = new Set(blocking.filter((b) => b.why === 'errors_unresolved').map((b) => b.item_id));
  const lr = view ? view.last_result : null;
  const replaceCard = lr && lr.kind === 'replace_card' && lr.card && typeof lr.card === 'object'
    && lr.card.proposal_hash !== approvedHash ? lr.card : null;
  const utterances = (view && Array.isArray(view.messages) ? view.messages : [])
    .filter((m) => m.role === 'user' && m.utterance_id != null);
  const heldCount = notify ? notify.held_count : (view && view.notify ? view.notify.held_count : 0);
  const notifyItem = items.some((it) => /알림/.test(`${it.text} ${it.expect_plain}`));
  const showRedeploy = !!view && !running && (changing >= REDEPLOY_AFTER_CHANGING || (!view.has_preview && view.can_redeploy));
  const datasets = spec && spec.spec && Array.isArray(spec.spec.datasets) ? spec.spec.datasets : [];

  const toolColumn = (
    <section aria-label="도구" style={{ ...section, width: mobile ? 'auto' : '240px', flexShrink: 0 }}>
      <h2 style={h2}>도구</h2>
      <form onSubmit={createTool} style={{ display: 'flex', gap: '6px', marginBottom: '8px' }}>
        <input aria-label="새 도구 이름" value={newName} maxLength={60} placeholder="도구 이름"
          onChange={(e) => setNewName(e.target.value)} style={{ ...input, flex: 1, minWidth: 0 }} />
        <button type="submit" style={btn('secondary', 'sm')}>새 도구</button>
      </form>
      {listMsg && <div role="alert" style={warnBox}>{listMsg}</div>}
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {tools.map((t) => (
          <li key={t.tool_id}>
            <button type="button" aria-pressed={t.tool_id === toolId} onClick={() => selectTool(t.tool_id)}
              style={{ ...btn('quiet', 'sm'), width: '100%', textAlign: 'left', color: COLORS.text,
                background: t.tool_id === toolId ? COLORS.primarySoft : 'transparent' }}>
              {t.name}{t.status !== 'active' ? ` (${t.status})` : ''}
            </button>
          </li>
        ))}
      </ul>
      {tools.length === 0 && !listMsg && <div style={sub}>아직 도구가 없습니다 — 이름을 적고 «새 도구»</div>}
      {toolId != null && (
        <button type="button" data-testid="aidev-archive" onClick={archiveTool} disabled={archiving}
          style={{ ...btn('secondary', 'sm'), marginTop: '8px' }}>도구 보관</button>
      )}
      <div data-testid="aidev-month-cost" style={{ ...sub, marginTop: '10px' }}>
        이번 달 비용(UTC 기준 월): {monthCost == null ? '계산 불가' : `$${monthCost.toFixed(2)}`}
      </div>
    </section>
  );

  const talkColumn = view && (
    <section aria-label="대화" style={{ ...section, flex: 1, minWidth: 0 }}>
      <h2 style={h2}>{view.tool ? view.tool.name : '도구'}</h2>
      <div style={sub}>
        상태: {STATUS_LABEL[view.status] || view.status} · 반복 {view.iterations} · 이 도구 비용 ${Number(view.cost_usd || 0).toFixed(2)}
      </div>
      <div data-testid="aidev-messages" style={{ margin: '10px 0', maxHeight: mobile ? 'none' : '420px', overflow: 'auto' }}>
        {(view.messages || []).map((m) => (
          <div key={m.id} style={{ margin: '6px 0', fontSize: '13px', whiteSpace: 'pre-wrap', color: COLORS.text }}>
            {m.text && <div><b>{m.role === 'user' ? '나' : m.role === 'assistant' ? 'AI' : '도구'}</b> {m.text}</div>}
            {m.tools > 0 && <div style={sub}>도구 {m.tools}개 실행</div>}
          </div>
        ))}
      </div>
      {lastResultText(lr) && <div data-testid="aidev-last-result" style={{ ...sub, whiteSpace: 'pre-wrap' }}>{lastResultText(lr)}</div>}
      {notice && <div role="alert" style={warnBox}>{notice}</div>}
      <textarea aria-label="AI 에게 할 말" value={text} maxLength={MAX_TEXT} rows={4} disabled={stopped}
        onChange={(e) => setText(e.target.value)} style={{ ...input, resize: 'vertical' }} />
      <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
        <button type="button" onClick={send} disabled={stopped || sending || running || !text.trim()} style={btn('primary')}>보내기</button>
        {running && <button type="button" onClick={stop} style={btn('danger')}>멈춤</button>}
      </div>
    </section>
  );

  const checkColumn = view && (
    <section aria-label="확인" style={{ ...section, flex: 1, minWidth: 0 }}>
      <h2 style={h2}>미리보기</h2>
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '6px' }}>
        {view.has_preview && (
          <button type="button" onClick={openPreview} disabled={stopped} style={btn('accent')}>
            {preview ? '미리보기 다시 열기' : '미리보기 열기'}
          </button>
        )}
        {showRedeploy && (
          <button type="button" onClick={redeploy} disabled={stopped || redeploying} style={btn('secondary')}>미리보기 다시 올리기</button>
        )}
      </div>
      {!view.has_preview && !view.can_redeploy && <div style={sub}>아직 미리보기가 없습니다</div>}
      {previewMsg && <div role="status" style={sub}>{previewMsg}</div>}

      <h2 style={{ ...h2, marginTop: '12px' }}>확인표</h2>
      {items.length === 0 && <div style={sub}>확인할 항목이 아직 없습니다</div>}
      {notifyItem && <div style={sub}>{NOTIFY_ITEM_NOTE}</div>}
      {blocking.some((b) => b.why === 'strength_unmeasured') && <div style={sub}>시험 강도 미측정 — 게시는 아직 없습니다</div>}
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {items.map((it) => {
          const isA = it.method === 'a';
          const r = results.get(it.item_id);
          const last = r ? r.last : null;
          const c = counts.get(it.item_id);
          let lastText = '사람 확인 항목';
          if (isA) {
            if (!last) lastText = '아직 시험 결과 없음';
            else if (last.result === 'pass') lastText = '통과';
            else if (last.result === 'fail') lastText = `실패: ${last.reason_plain || '사유 없음'}`;
            else lastText = '시험 기계 오류';
          }
          const canConfirm = !!preview && !stopped && (!isA || !!(r && r.pass_result_id));
          return (
            <li key={it.item_id} data-testid="aidev-item" style={{ borderTop: `1px solid ${COLORS.borderSoft}`, padding: '6px 0', fontSize: '13px' }}>
              <div>{it.text}</div>
              <div style={sub}>기대: {it.expect_plain}</div>
              <div style={sub}>{isA ? `최근 시험(이 묶음 또는 묶음 모름): ${lastText}` : lastText}</div>
              {c && <div style={sub}>실패 {c.fail_count_version} · 오류 {c.error_count_bundle}</div>}
              {unresolved.has(it.item_id) && <div style={sub}>시험 기계 오류가 풀리지 않음</div>}
              <button type="button" disabled={!canConfirm}
                onClick={() => confirmSeen(it.item_id, isA ? r.pass_result_id : null)} style={btn('secondary', 'sm')}>이 항목 맞다</button>
            </li>
          );
        })}
      </ul>
      <button type="button" disabled={!preview || stopped} onClick={() => confirmSeen(null, null)}
        style={{ ...btn('primary', 'sm'), marginTop: '8px' }}>전체 맞다</button>
      {checkMsg && <div role="status" style={sub}>{checkMsg}</div>}

      <form onSubmit={addHuman} aria-label="사람 확인 항목 추가" style={{ marginTop: '10px', display: 'grid', gap: '4px' }}>
        <div style={{ ...h2, marginBottom: 0 }}>사람 확인 항목 추가</div>
        <select aria-label="근거 발화" value={human.utteranceId} onChange={(e) => setHuman({ ...human, utteranceId: e.target.value })} style={input}>
          <option value="">근거 발화 고르기</option>
          {utterances.map((m) => <option key={m.id} value={String(m.utterance_id)}>{m.text.slice(0, 60)}</option>)}
        </select>
        <input aria-label="확인할 것" value={human.text} maxLength={300} placeholder="확인할 것"
          onChange={(e) => setHuman({ ...human, text: e.target.value })} style={input} />
        <input aria-label="기대" value={human.expect} maxLength={300} placeholder="기대"
          onChange={(e) => setHuman({ ...human, expect: e.target.value })} style={input} />
        <button type="submit" disabled={!human.utteranceId || !human.text.trim() || !human.expect.trim()} style={btn('secondary', 'sm')}>항목 더하기</button>
      </form>

      {replaceCard && (
        <div data-testid="aidev-replace-card" style={{ ...section, marginTop: '10px' }}>
          <div style={h2}>교체 카드</div>
          <div style={{ display: 'grid', gridTemplateColumns: mobile ? '1fr' : '1fr 1fr', gap: '8px', fontSize: '12px' }}>
            {[['지금', replaceCard.old], ['바꿀 것', replaceCard.new]].map(([label, side]) => (
              <div key={label}>
                <b>{label}</b>
                <div>{side && side.text}</div>
                <div style={sub}>기대: {side && side.expect_plain}</div>
                <div style={sub}>{summaryText(side && side.check_summary)}</div>
              </div>
            ))}
          </div>
          <button type="button" onClick={() => approveReplace(replaceCard)} style={{ ...btn('primary', 'sm'), marginTop: '6px' }}>바꾸기 승인</button>
        </div>
      )}
      {!replaceCard && cardGone && <div style={warnBox}>{CARD_GONE_TEXT}</div>}

      <h2 style={{ ...h2, marginTop: '12px' }}>명세 승인 카드</h2>
      {spec ? (
        <div data-testid="aidev-spec-card">
          {datasets.map((d, i) => (
            <div key={i} style={{ fontSize: '13px' }}>
              데이터셋 {showInvisible(d && d.id != null ? d.id : '-')} · 화주 {d && d.shipper ? showInvisible(d.shipper) : SHIPPER_ALL}
              {d && d.center ? ` · 센터 ${showInvisible(d.center)}` : ''}
            </div>
          ))}
          <pre style={{ fontSize: '11px', whiteSpace: 'pre-wrap', background: COLORS.borderSoft, padding: '6px', borderRadius: '5px' }}>
            {showInvisible(JSON.stringify(spec.spec, null, 2))}
          </pre>
          <button type="button" onClick={approveSpec} disabled={stopped} style={btn('primary', 'sm')}>승인</button>
        </div>
      ) : null}
      {specMsg && <div role="status" style={sub}>{specMsg}</div>}

      <h2 style={{ ...h2, marginTop: '12px' }}>알림</h2>
      <div data-testid="aidev-notify" style={sub}>미리보기에서 앱이 보낸 알림 {heldCount}건은 실제로 가지 않았습니다(보류)</div>
      {notify && (notify.held.length > 0 || notify.intercepted.length > 0) && (
        <button type="button" onClick={() => setNotifyOpen(!notifyOpen)} style={btn('quiet', 'sm')}>{notifyOpen ? '접기' : '목록 펼치기'}</button>
      )}
      {notifyOpen && notify && (
        <div style={{ fontSize: '12px' }}>
          {notify.held.map((m, i) => <div key={`h${i}`}>보류 · {m.at} · {m.body}</div>)}
          {notify.intercepted.map((m, i) => <div key={`i${i}`}>AI 시험 중 가로챔 · {m.at} · {m.body}</div>)}
        </div>
      )}
    </section>
  );

  // 세 칸 위 전체 폭 띠 — 바깥 상자 → 자리(배율 크기 · 스크롤 폭을 만든다) → iframe(1280×800 · transform).
  // 🔴 구조는 폭·접힘과 무관하게 늘 같다(iframe 이 다시 실리지 않게) · 접힘은 바깥 상자 높이 0(display:none 이면 폭이 0 이 된다).
  const scaledW = Math.round(FRAME_W * scale);
  const scaledH = Math.round(FRAME_H * scale);
  const previewStrip = view && preview && (
    <section aria-label="미리보기 화면" data-testid="aidev-preview-strip" style={{ marginBottom: '10px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px' }}>
        <h2 style={{ ...h2, margin: 0 }}>미리보기 화면</h2>
        <button type="button" aria-expanded={!previewFolded} onClick={() => setPreviewFolded(!previewFolded)}
          style={btn('quiet', 'sm')}>{previewFolded ? '미리보기 펼치기' : '미리보기 접기'}</button>
      </div>
      <div ref={boxRef} data-testid="aidev-preview-box" style={{ width: '100%', boxSizing: 'border-box',
        height: previewFolded ? '0px' : `${scaledH}px`, overflowX: 'auto', overflowY: 'hidden',
        border: previewFolded ? 'none' : `1px solid ${COLORS.borderSoft}`, borderRadius: '5px',
        margin: previewFolded ? 0 : '6px 0' }}>
        <div style={{ width: `${scaledW}px`, height: `${scaledH}px`, position: 'relative', overflow: 'hidden' }}>
          <iframe key={preview.key} ref={frameRef} title="미리보기 틀" src={FRAME_SRC} width={FRAME_W} height={FRAME_H}
            onLoad={onFrameLoad}
            style={{ position: 'absolute', left: 0, top: 0, width: `${FRAME_W}px`, height: `${FRAME_H}px`, border: 0,
              display: 'block', transform: `scale(${scale})`, transformOrigin: '0 0' }} />
        </div>
      </div>
    </section>
  );

  // «사용법 묻기» 떠 있는 판 — 세 칸을 밀어내지 않는다(넓은 화면 오른쪽 아래 380px · 모바일 하단 탭바 위 전체 폭 · 높이 최대 70dvh).
  const helpPanel = helpOpen && (
    <section id="aidev-help-panel" data-testid="aidev-help-panel" aria-labelledby="aidev-help-title"
      style={{ ...card, padding: '12px 14px', position: 'fixed', zIndex: 900, boxShadow: SHADOW.float,
        display: 'flex', flexDirection: 'column', maxHeight: '70dvh', boxSizing: 'border-box',
        ...(mobile
          ? { left: 0, right: 0, bottom: tabbarCalc(0), width: '100%', borderRadius: '10px 10px 0 0' }
          : { right: '20px', bottom: '20px', width: '380px' }) }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px' }}>
        <h2 id="aidev-help-title" style={{ ...h2, margin: 0 }}>아우리에게 AI 개발실 사용법 묻기</h2>
        <button type="button" aria-label="사용법 묻기 닫기" onClick={closeHelp} style={btn('icon')}>×</button>
      </div>
      <div style={sub}>이 대화는 저장되지 않습니다</div>
      {/* 판 높이는 내용만큼(최대 70dvh) — 목록은 내용 크기에서 출발해 넘치면 줄어들며 스크롤(flex-basis 0 이면 0 높이로 접힌다) */}
      <div data-testid="aidev-help-list" aria-live="polite" style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', margin: '8px 0' }}>
        {helpTurns.map((t, i) => (
          <div key={i} data-testid="aidev-help-turn" data-role={t.role}
            style={{ display: 'flex', justifyContent: t.role === 'user' ? 'flex-end' : 'flex-start', margin: '4px 0' }}>
            {/* 아우리 답 = Markdown(whiteSpace normal — pre-wrap 이면 블록 사이 "\n" 이 빈 줄로 보인다 · 흰 바탕+테두리 — 표·code 테두리가 안 묻힌다)
                · 한 줄 줄바꿈은 그릴 때만 mdHardBreaks 로 지킨다(state·helpPayload 는 날 글자) */}
            <div data-testid={t.role === 'user' ? undefined : 'aidev-help-answer'}
              style={{ maxWidth: '85%', padding: '6px 9px', borderRadius: '8px', fontSize: '13px',
                wordBreak: 'break-word', color: COLORS.text,
                ...(t.role === 'user'
                  ? { whiteSpace: 'pre-wrap', background: COLORS.primarySoft }
                  : { whiteSpace: 'normal', background: COLORS.surface, border: `1px solid ${COLORS.border}` }) }}>
              {t.role === 'user' ? t.content : <Markdown compact>{mdHardBreaks(t.content)}</Markdown>}
            </div>
          </div>
        ))}
        {helpBusy && <div role="status" style={sub}>답을 쓰는 중…</div>}
      </div>
      {helpErr && <div role="alert" style={warnBox}>{helpErr}</div>}
      <textarea ref={helpInputRef} aria-label="아우리에게 물을 말" value={helpText} maxLength={HELP_MAX_TEXT} rows={2}
        readOnly={helpBusy} placeholder="예: 새 도구는 어떻게 만들어요?" onKeyDown={helpKeyDown}
        onChange={(e) => setHelpText(e.target.value)} style={{ ...input, resize: 'vertical' }} />
      <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
        <button type="button" onClick={() => askHelp()} disabled={helpBusy || !helpText.trim()} style={btn('primary', 'sm')}>묻기</button>
        <button type="button" onClick={clearHelp} disabled={helpBusy || helpTurns.length === 0} style={btn('secondary', 'sm')}>대화 지우기</button>
      </div>
    </section>
  );

  return (
    <AppShell app="apps">
      <main style={{ flex: 1, minWidth: 0, height: 'var(--gw-app-h, 100dvh)', overflow: 'auto', background: `var(--gw-bg, ${COLORS.bg})`, padding: mobile ? '10px' : '16px 20px', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '0 0 10px' }}>
          <h1 style={{ margin: 0, fontSize: '17px', fontWeight: 600, color: COLORS.text }}>AI 개발실</h1>
          <button type="button" ref={helpToggleRef} data-testid="aidev-help-toggle" aria-expanded={helpOpen}
            aria-controls="aidev-help-panel" onClick={() => (helpOpen ? closeHelp() : setHelpOpen(true))}
            style={btn('accent', 'sm')}>사용법 묻기</button>
        </div>
        {stopped && <div role="alert" data-testid="aidev-global-stop" style={warnBox}>{STOP_BANNER}</div>}
        {previewStrip}
        {helpPanel}
        <div style={{ display: 'flex', flexDirection: mobile ? 'column' : 'row', gap: '10px', alignItems: 'flex-start' }}>
          {toolColumn}
          {talkColumn}
          {checkColumn}
          {toolId && !view && <div style={sub}>불러오는 중…</div>}
        </div>
      </main>
    </AppShell>
  );
}
